<template>
  <v-container fluid="fluid" grid-list-md="grid-list-md">
    <v-card>
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.invoiceReadyToBeMade") }}</h1>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12="xs12" md4="md4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
          >
          </v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="invoice"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
      >
        <template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left">
              <div>
                <a @click="gotoPageNewTab(props.item)">{{ props.item.Store.CSPID }}</a>
                <v-icon small="small" v-if="props.item.isLocked">lock</v-icon>
              </div>
            </td>
            <td class="text-xs-left" @click="open(props.item)">
              {{ $moment(props.item.dueDate).format("MM/DD/YYYY") }}
            </td>
            <td class="text-xs-left" @click="open(props.item)">
              {{ props.item.Store.businessName }}
            </td>
            <td class="text-xs-left" @click="open(props.item)">
              {{ props.item.Store.businessPhone | USPhoneNumber }}
            </td>
            <td class="text-xs-left" v-if="props.item.Product" @click="open(props.item)">
              {{ props.item.Product.productDetail }}
            </td>
            <td class="text-xs-left" v-else @click="open(props.item)">
              Wrong product set (edit invoice & change product)
            </td>
            <td class="text-xs-right" @click="open(props.item)">
              {{ props.item.invoiceAmount | currency }}
            </td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left" offset-y="offset-y">
                <v-btn slot="activator" icon="icon">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="menu-button">
                  <v-list-tile @click="open(props.item)">
                    <v-list-tile-title>{{ $t("buttons.openStorePage") }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider> </v-divider>
                  <v-list-tile @click="createInvoice(props.item)">
                    <v-list-tile-title>{{ $t("buttons.createInvoice") }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </v-container>
</template>

<script>
import invoiceService from "../service.js";
import { mapGetters } from "vuex";

export default {
  name: "ready-to-be-made",
  data() {
    return {
      invoice: [],
      loading: true,
      headers: [
        {
          text: this.$t("labels.cspid"),
          value: "Store.CSPID",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.dueDate"),
          value: "dueDate",
          sortable: true,
          width: "10%"
        },
        {
          text: this.$t("labels.businessName"),
          value: "Store.businessName",
          sortable: true
        },
        {
          text: this.$t("labels.phoneNumber"),
          value: "Store.businessPhone",
          sortable: true
        },
        {
          text: this.$t("labels.plan"),
          value: "Product.productDetail",
          sortable: true
        },
        {
          text: this.$t("labels.amount"),
          value: "invoiceAmount",
          sortable: true
        },
        // {
        //   text: this.$t('labels.lastUsed'),
        //   value: 'AttandanceDateTime',
        //   width: '10%',
        //   sortable: true,
        // },
        {
          text: "",
          value: "action",
          sortable: false
        }
      ],
      search: null,
      pagination: {
        rowsPerPage: 10,
        sortBy: "Store.businessName",
        descending: true
      }
    };
  },
  created() {
    this.getReadyToBeMadeInvoice();
  },
  // activated() {
  //   this.getReadyToBeMadeInvoice()
  // },
  methods: {
    open(data) {
      this.$router.push({ path: `/location/profile/${data.storeID}` });
    },
    createInvoice(data) {
      this.$swal({
        title: "Are you sure?",
        // text: "You won't be able to revert this!",
        html: `You like to create invoice for <strong style="font-weight: bold;">${data.Store.businessName}</strong> for <strong style="font-weight: bold;">${this.$options.filters.currency(data.invoiceAmount)}.</strong> Invoice will send to ${data.Store.invoiceEmail}`,
        type: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Create"
      }).then(result => {
        if (result.value) {
          this.$Progress.start();
          return invoiceService
            .renewInvoice(data.storeID, data.serviceID)
            .then(response => {
              if (response.data) {
                this.$swal("Created!", "Invoice was created successfully", "success");
                this.$Progress.finish();
                this.getReadyToBeMadeInvoice();
              }
            })
            .catch(error => {
              this.$swal
                .mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000
                })
                .fire({
                  type: "error",
                  title: error.data.message
                });
              this.$Progress.fail();
            });
        }
      });
    },
    gotoPageNewTab(data) {
      let routeData = this.$router.resolve({ path: `/location/profile/${data.storeID}` });
      window.open(routeData.href, "_blank");
    },
    getReadyToBeMadeInvoice() {
      this.loading = true;
      return invoiceService.getReadyToBeMadeInvoice().then(response => {
        console.log("open invoice list", response);
        this.invoice = response.data;
        this.loading = false;
        return response;
      });
    }
  }
};
</script>

<style scoped></style>
